import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dda4350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-home-wrapper" }
const _hoisted_2 = { class: "view-home-middle" }
const _hoisted_3 = {
  class: "view-home-body",
  id: "view-home-body"
}
const _hoisted_4 = { class: "home-wrapper__content" }
const _hoisted_5 = {
  key: 0,
  class: "background-editor__mask"
}
const _hoisted_6 = { class: "editor__edit-tips" }
const _hoisted_7 = { class: "editor__edit-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "view-home-middle-h5-preview"
}

import { computed, toRefs, ref, watch, nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import TeamHead from '@/components/teamHead/Index.vue'
import { useTeamHead } from '@/components/teamHead'
import type { TeamHeadInst } from '@/components/teamHead'
import { HorizonalNavs } from '@/components/navigator'
import Aside from './aside.vue'
import useViewConfig from '@/hooks/useViewConfig'
import { useNavigatorStore } from '@/store/navigator'
import { useGroupStore } from '@/store/group'
import { useUserStore } from '@/store/user'
import BackgroundEditor, {
  useBackgroundEditor
} from '@/components/backgroundEditor'
import useNav from '@/components/navigator/useNav'
import { useAcl } from 'vue-simple-acl'
import { getCreateTemplateGroupTimes } from '@teams/common/api'
import aclRules from '@teams/common/acl/aclRules'
import usePreference from '@teams/common/hooks/usePreference'
import { groupHeadBackgroundImg } from '@teams/common/store/preference/constant'
import CustomPanel from '@/components/customPanel/index.vue'
//  TODO: 12/20 隐藏悬浮球
// import FloatBall from '@/components/customPanel/floatBall.vue'
import { usePreview, useH5Preview, H5Preview } from './preview'
import { getBoolean } from '@/utils'
import Icon from '@teams/common/components/icon'
import { useI18n } from 'vue-i18n'
import useShepherd, { customCssClasses } from '@/hooks/useShepherd'
import useMitt from '@/hooks/useMitt'
import { events, elementIds } from '@/constants'
import { useSessionStorage } from '@vueuse/core'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    groupId: null,
    navId: null,
    customStyles: { default: () => ({
      // 导航栏背景色
      asideBackgroundColor:
        'var(--PC-nav-background-color, var(--theme-team-02))'
    }) }
  },
  setup(__props: any) {

const props = __props as { groupId: number, navId?: number, customStyles: {
      asideBackgroundColor?: string
    } }

_useCssVars(_ctx => ({
  "29c1d81c": (_unref(backgroundEditor).imgUrlCss),
  "5ff1f880": (__props.customStyles.asideBackgroundColor),
  "5b6c58a8": (_unref(contentWrapperStyles).borderTopLeftRadius)
}))

const teamHeadRef = ref<TeamHeadInst>()
const preference = usePreference()
// rbac更换背景
const acl = useAcl()
const rbacGroupBgimage = computed(() =>
  acl.can(aclRules.group_head_update_group_bgimage)
)
//  TODO: 12/20 隐藏悬浮球
// const rbacShowFloatBall = computed(() =>
//   acl.can(aclRules.navigation_custom_interface_entrance)
// )
// 团队成员列表入口
const rbacShowTeamMember = computed(() => acl.can(aclRules.member_list_view))
// 国际化
const { t } = useI18n()
const tBasePrefix = ref<string>('components.backgroundEditor')
const { toViewContent } = useNav()

const showNav = computed(() => preference.current.layout.showNavBar !== 'false')
const preferenceInited = computed(() => preference.store.hasInit)
const {
  shouldStickyGroupPanel,
  useAsideNav,
  showCustomPanel
  //  TODO: 12/20 隐藏悬浮球
  // toggleCustomPanel
  // showFloatBall
} = useViewConfig()
const navigatorStore = useNavigatorStore()
const groupStore = useGroupStore()
const userStore = useUserStore()
const { groupId } = toRefs(props)
const { multiState } = useAccountChange()
const contentWrapperStyles = computed(() => ({
  borderTopLeftRadius: useAsideNav.value ? '12px' : undefined
}))

const teamHead = useTeamHead({
  showTeamMemberEntry: computed(() => {
    return rbacShowTeamMember.value
  }),
  isVisitor: computed(() => {
    return acl.can(aclRules.not_group_member)
  }),
  isLogin: computed(() => {
    return !!userStore.userId
  }),
  stickyGroupPanel: shouldStickyGroupPanel,
  hiddenTeamSpace: computed(
    () => getBoolean(preference.current.layout.hiddenTeamSpace) || false
  ),
  hiddenTeamMember: computed(
    () => getBoolean(preference.current.layout.hiddenTeamMember) || false
  ),
  hiddenShareBtn: computed(
    () => getBoolean(preference.current.layout.hiddenShareBtn) || false
  ),
  hiddenMessageAlert: computed(
    () => getBoolean(preference.current.layout.hiddenMessageAlert) || false
  ),
  isEase: computed(() => getBoolean(preference.current.layout.isEase))
})
const isVisitor = computed(() => {
  return acl.can(aclRules.not_group_member)
})
// 访客在导航有数据时显示导航
const showNavigator = computed(() => {
  if (!isVisitor.value) {
    return true
  }
  return !!navigatorStore.list.length
})

async function init() {
  await navigatorStore.getNavs()
  // url无nid或nid对应导航不存在时跳转到第一个
  if (
    !props.navId ||
    !navigatorStore.list.find(nav => nav.id === props.navId)
  ) {
    const nav = navigatorStore.list[0] || {}
    toViewContent(nav)
  }
}

init()
const backgroundImgUrl = computed(
  () => preference.current.theme.styles[groupHeadBackgroundImg] as string
)
const backgroundEditor = useBackgroundEditor(groupId.value, {
  url: backgroundImgUrl,
  onChange: async () => {
    await groupStore.refreshCurrentAdditionalInfo()
  },
  allowEdit: computed(() => !isVisitor.value) && rbacGroupBgimage,
  showBackgroundMaskBlur:
    computed(() =>
      getBoolean(
        preference.current.theme.styles['PC-background-blur-mask-visible'] ===
          'true'
      )
    ) || false,
  usePcBackgroundToH5:
    computed(() =>
      getBoolean(preference.current.theme.styles['use-pc-background-to-h5'])
    ) || false
})

const preview = usePreview()
const h5Preview = useH5Preview()

// TODO: 12.20 隐藏悬浮球
// const openCustomPanel = () => {
//   toggleCustomPanel()
// }
// const entryClientPC = () => {
//   preview.setInPreview(true)
//   h5Preview.hide()
// }
// const entryClientH5 = () => {
//   preview.setInPreview(true)
//   h5Preview.show()
// }
// -1 初始值与接口数据的 0 区分开，这不是好做法，用 loaded 判断更好
const createTemplateGroupTimes = ref(-1)
const tour = useShepherd({ useModalOverlay: true })
const addNavBtnRef = ref<HTMLElement>()
const customPreferenceDropdownRef = ref<HTMLElement>()
const { listLoaded } = storeToRefs(navigatorStore)
let tourTriggered = false

const fetchCreateTemplateGroupTimes = async () => {
  try {
    const { data } = await getCreateTemplateGroupTimes()
    createTemplateGroupTimes.value = data.num
  } catch (e) {
    //
  }
}

fetchCreateTemplateGroupTimes()
tour.addSteps([
  {
    id: 'addNav',
    attachTo: {
      element: () => addNavBtnRef.value,
      on: 'bottom'
    },
    title: '添加标签页',
    text: '可添加更多视图',
    buttons: [
      {
        text: '跳过',
        action: tour.complete,
        classes: customCssClasses.firstStep
      },
      {
        text: '下一步',
        action() {
          teamHeadRef.value?.setDropdownVisible(true)
        },
        classes: customCssClasses.buttonPrimary
      }
    ],
    canClickTarget: false,
    modalOverlayOpeningPadding: 16,
    modalOverlayOpeningRadius: 10
  },
  {
    id: 'customPreference',
    attachTo: {
      element: () => customPreferenceDropdownRef.value,
      on: 'left'
    },
    title: '自定义界面',
    text: '可更改界面布局',
    buttons: [
      {
        text: '知道了',
        action() {
          teamHeadRef.value?.setDropdownVisible(false)
          return tour.complete()
        },
        classes: customCssClasses.secondStepAddButtonPrimary
      }
    ],
    canClickTarget: false,
    modalOverlayOpeningPadding: 6,
    modalOverlayOpeningRadius: 10
  }
])

const handleDropdownClickoutside = () => {
  if (tour.isActive()) {
    teamHeadRef.value?.setDropdownVisible(true)
  }
}

const emitter = useMitt()
const isTurnonBooting = useSessionStorage('isTurnonBooting', false)
const onElementRendered = (params: any = {}) => {
  const key: string = params?.key
  const value: HTMLElement = params?.value
  switch (key) {
    case elementIds.addNavBtn: {
      addNavBtnRef.value = value
      break
    }
    case elementIds.customPreferenceDropdownOption: {
      if (!customPreferenceDropdownRef.value) {
        customPreferenceDropdownRef.value = value
        tour.next()
      }
      break
    }
  }
}

emitter.on(events.elementRendered, onElementRendered)
// 缩放页面时，暂时直接关闭最后一步的引导，避免出现页面错误，dropdwon列表的更新会引起引导错误
window.addEventListener('resize', async () => {
  if (customPreferenceDropdownRef.value) {
    if (tour.isActive()) {
      tour.complete()
      await nextTick()
      teamHeadRef.value?.setDropdownVisible(false)
    }
  }
})
watch(
  [listLoaded, addNavBtnRef, createTemplateGroupTimes, preferenceInited],
  async ([
    navsLoaded,
    addNavBtn,
    createTemplateGroupTimes,
    preferenceInited
  ]) => {
    const createTemplateGroupTimesMatched =
      createTemplateGroupTimes >= 0 && createTemplateGroupTimes <= 3
    // 创建团队引导第一步是定位 "添加导航标签" 元素
    // 该元素位置需导航列表获取后才能确定，否则产生错位
    // isWatchDone 对当前页面只监听一次，避免改变横竖导航栏时重新触发 引导
    if (
      preferenceInited &&
      navsLoaded &&
      addNavBtn &&
      createTemplateGroupTimesMatched &&
      !tourTriggered &&
      isTurnonBooting.value
    ) {
      await nextTick()
      tourTriggered = true
      // 暂不开启引导
      // tour.start()
      isTurnonBooting.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NSlider = _resolveComponent("NSlider")!
  const _component_NSpace = _resolveComponent("NSpace")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BackgroundEditor), _mergeProps({ class: "view-home-wrapper--img" }, _unref(backgroundEditor).props), {
      default: _withCtx(({ showEditor, editor, handleHeadContextMenu }) => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["view-home-header", [_unref(backgroundEditor).imgUrl ? '' : 'view-home-header--color']])
          }, [
            _createVNode(TeamHead, _mergeProps(_unref(teamHead).props, {
              onContextmenu: handleHeadContextMenu,
              "onClickoutside:dropdown": handleDropdownClickoutside,
              ref_key: "teamHeadRef",
              ref: teamHeadRef
            }), null, 16, ["onContextmenu"]),
            (
              !_unref(useAsideNav) &&
              _unref(showNavigator) &&
              _unref(showNav) &&
              !_unref(multiState).isChangeAccount
            )
              ? (_openBlock(), _createBlock(_unref(HorizonalNavs), { key: 0 }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            (
              _unref(useAsideNav) &&
              _unref(showNavigator) &&
              _unref(showNav) &&
              !_unref(multiState).isChangeAccount
            )
              ? (_openBlock(), _createBlock(Aside, {
                  key: 0,
                  class: "view-home-aside"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_view),
              showEditor
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)(`${tBasePrefix.value}.editorEditTips`)), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_NSpace, {
                        size: 30,
                        justify: "center",
                        vertical: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NSpace, {
                            size: 8,
                            align: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Icon), {
                                class: "editor__edit-toolbar-zoom",
                                name: "bgZoomMinus",
                                size: 24,
                                fill: "transparent",
                                onClick: ($event: any) => (editor.cropperZoom(-0.1))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_NSpace, {
                                size: 8,
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NSlider, {
                                    class: "editor__edit-slider-progress",
                                    value: editor.percentValue,
                                    "onUpdate:value": ($event: any) => ((editor.percentValue) = $event),
                                    step: 10
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(Icon), {
                                class: "editor__edit-toolbar-zoom",
                                name: "bgZoomAdd",
                                size: 24,
                                fill: "transparent",
                                onClick: ($event: any) => (editor.cropperZoom(0.1))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_NSpace, {
                            size: 12,
                            justify: "center",
                            align: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NButton, {
                                class: "editor__edit-toolbar-btn editor__edit-toolbar-btn--cancel",
                                tertiary: "",
                                round: "",
                                onClick: editor.onCancel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)(`${tBasePrefix.value}.editorEditCancle`)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_NButton, {
                                class: "editor__edit-toolbar-btn",
                                round: "",
                                type: "primary",
                                onClick: editor.onCrop
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)(`${tBasePrefix.value}.editorEditConfirm`)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 512), [
          [_vShow, !_unref(preview).inPreview || !_unref(h5Preview).isShow]
        ]),
        (_unref(preview).inPreview)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(H5Preview))
            ], 512)), [
              [_vShow, _unref(h5Preview).isShow]
            ])
          : _createCommentVNode("", true),
        (_unref(showCustomPanel))
          ? (_openBlock(), _createBlock(CustomPanel, {
              key: 1,
              class: "view-home-right"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16)
  ]))
}
}

})